import { Controller } from "@hotwired/stimulus"

// Clears the input after the form has been submitted via Turbo so the user
// can keep adding items without manually emptying it.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.element.addEventListener("turbo:submit-end", (event) => {
      if (event.detail.success) this.inputTarget.value = ""
    })
  }
}
